// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".LoyaltyContactFormTextArea-module-textareaWrapper-1V2bX{width:100%;gap:0;margin-block-end:0}.LoyaltyContactFormTextArea-module-textareaWrapper-1V2bX>div:first-child{padding-inline:0;padding-block:0}", ""]);
// Exports
exports.locals = {
	"textareaWrapper": "LoyaltyContactFormTextArea-module-textareaWrapper-1V2bX"
};
module.exports = exports;
